import Select from 'features/common/components/Select'
import {useTypedTranslation} from 'i18n'

type DateSelectType = {
    value: number | null
    placeholder: string
    onChange: (value: number) => void
    options: {value: number; label: string}[]
}

const DateSelect = ({
    placeholder,
    value,
    onChange,
    options,
}: DateSelectType) => {
    const {t} = useTypedTranslation()
    const isPlaceholder = value === null
    const currentLabel = isPlaceholder
        ? placeholder
        : options.find((op) => op.value === value)?.label || value.toString()
    return (
        <Select value={value} onChange={onChange}>
            <Select.Button
                className={`h-10 ${isPlaceholder ? 'text-grey-20' : ''}`}
            >
                {t(currentLabel)}
            </Select.Button>
            <Select.Options className="overflow-hidden pr-1">
                <div className="max-h-32 overflow-y-auto overflow-x-hidden">
                    {options.map((op) => (
                        <Select.Option
                            className="h-10"
                            key={op.value}
                            value={op.value}
                        >
                            {t(op.label)}
                        </Select.Option>
                    ))}
                </div>
            </Select.Options>
        </Select>
    )
}

export default DateSelect
